<script>
import { Line, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'EnergySavingChart',
  extends: Line,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = '%';
                    if (label) {
                        label += ': ';
                    }
                    label += value + ' ' + unit;
                    return label;
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
                stacked: true
            }],
            yAxes: [{
                stacked: false,
                ticks: {
                  min:0,
                  max: 100,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = '%';
                      label += value + ' ' + unit;
                      return label;
                    }
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>